import styled from 'styled-components';

export const Button = styled.button`
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0 10px;
  cursor: pointer;
  flex: 0 0 auto;
  border-radius: 50%;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  color: #47b972;
  font-size: 1rem;
  svg {
    user-select: none;
    width: 1em;
    height: 1em;
    display: inline-block;
    flex-shrink: 0;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    /* fill: #47b972; */
    fill: #fff;
    font-size: 1.5rem;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &.with-bg {
    /* background-color: rgba(0, 0, 0, 0.5); */
    svg {
      fill: ${(props) => (props.theme.theme === 'dark' ? '#fff' : '#000')};
    }
  }
`;
